export default __webpack_public_path__ + "static/chaos-4e77ad2eaaf9b2aabc8a05b558bf5e2c.png";